import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import userIcon from "../../assets/user_approved.png";
import LoadingOverlay from "../Dashboard/Common/LoadingOverlay";

const ApproveUser = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { approvalCode } = useParams();
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (approvalCode) {
      approveUser(approvalCode);
    }
  }, [approvalCode]);

  const approveUser = async (code) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${apiUrl}/auth:approve_user?approval_code=${code}`
      );
      if (response.ok) {
        setStatus("User Approved.");
      } else {
        setStatus("Verification failed. Please try again.");
      }
    } catch (error) {
      setStatus("An error occurred. Please try again.");
    }
    setIsLoading(false);
  };

  const navigateToLogin = () => {
    navigate("/login");
  };

  return (
    <>
      {isLoading ? (
        <LoadingOverlay />
      ) : (
        <div className="overlay">
          <div className="confirmation-modal">
            <button className="close-button">&times;</button>
            <div className="modal-content  ">
              <div>
                <img src={userIcon} alt="User Icon" className="user-icon " />
              </div>

              <p>{status}</p>
              <button className="resend-button" onClick={navigateToLogin}>
                Back to Log In
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ApproveUser;
